import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import './App.scss';

import Navbar from './components/Navbar/index';
import Footer from './components/Footer/index';

import Home from './pages/Home/index';
import Features from './pages/Features/index';
import Pricing from './pages/Pricing/index';
import Resources from './pages/Resources/index';

// TO DO:
// - Improve link-copy functionality

function App() {
  return (
    <BrowserRouter>
      <div className='App'>
        <Navbar />
        <Route path='/' exact>
          <Home />
        </Route>
        <Route path='/features' exact>
          <Features />
        </Route>
        <Route path='/pricing' exact>
          <Pricing />
        </Route>
        <Route path='/resources' exact>
          <Resources />
        </Route>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
